export const SET_MY_INFO = 'SET_MY_INFO'
export const DELETE_ORDER = 'DELETE_ORDER'
export const SET_CURRENT_COUPON = 'SET_CURRENT_COUPON'
export const SET_FAQ = 'SET_FAQ'
export const SET_USERNAME = 'SET_USERNAME'
export const REFUND_CHECK = 'REFUND_CHECK'
export const REFUND_SUBMIT = 'REFUND_SUBMIT'



// WEBPACK FOOTER //
// ./src/store/my/mutation-types.js